<template>
  <validation-observer ref="StateForm">
    <b-form class="formBox">
      <validation-provider
        name="Güncel Ticket durumunu"
        :rules="{ required: true }"
        v-slot="validationContext"
      >
        <b-form-group class="inputGrp" label="Güncel Ticket durumunu aşağıdaki listeden seçiniz.">
          <Multiselect
            v-model="state"
            :show-labels="false"
            :options="options"
            @input="setState"
            :state="getValidationState(validationContext)"
            label="description"
            track-by="id"
          >
            <template slot="singleLabel" slot-scope="{ option }">
              <strong>{{ option.description }} </strong>
            </template>
          </Multiselect>
          <b-form-invalid-feedback id="live-feedback" style="display: block">{{
            validationContext.errors[0]
          }}</b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>
    </b-form>
  </validation-observer>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: "StateForm",
  components: {
    Multiselect
  },
  props: {
    data: Object,
    modalName: String,
    modalEvent: Function,
    save: Boolean,
    saveState: Function,
  },
  data: function () {
    return {
      state: null,
      stateId: '',
    };
  },
  watch: {
    save: async function (data) {
      if (data) {
        this.$refs.StateForm.validate().then(async (success) => {
          if (success) {
            let reqData = {
              ticket_id: this.data.ticket_id ? this.data.ticket_id  : this.data.ticket.id ,
              status_id: this.stateId
            }
            await this.$store.dispatch('setTicketState', reqData)

            if(this.$store.getters.getTicketStatus == 'Success') {
              this.$store.dispatch('fetchTickets')
              if(this.$route.path !== '/Ticket/List')
                this.$router.push('/Ticket/List')
              this.clearForm();
            }
          }
            this.saveState(false);

        });
      }
    },
  },
  computed: {
    options() {
      return this.$store.getters.getTicketStatuses
    },
  },
  methods: {
    setState(val) {
      this.stateId = val.id
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    clearForm() {
      this.saveState(false);
      this.modalEvent(false);
    },
  },
  created() {
    this.$store.dispatch('ticketStatus')
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/Support/Ticket/modals/ChangeState.vue